import React, { useState } from "react";
import { useLanguage } from "../contexts/LanguageContext";

const LANGUAGES = [
  { code: "en", name: "English", short: "EN", flag: "🇺🇸" },
  { code: "ar", name: "العربية", short: "AR", flag: "🇹🇳" },
  { code: "fr", name: "Français", short: "FR", flag: "🇫🇷" },
];

const LanguageSwitcher = () => {
  const { language, changeLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const currentLanguage = LANGUAGES.find((lang) => lang.code === language);

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className={`language-switcher language-switcher-v2${isOpen ? " is-open" : ""}`}>
      <button
        type="button"
        className="language-switcher-button language-switcher-button-v2"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Change language"
        aria-expanded={isOpen}
        aria-haspopup="listbox"
      >
        <span className="language-flag">{currentLanguage?.flag}</span>
        <span className="language-code">{currentLanguage?.short}</span>
        <i className="fas fa-chevron-down language-chevron" aria-hidden="true"></i>
      </button>

      {isOpen && (
        <div className="language-dropdown language-dropdown-v2" role="listbox">
          {LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              type="button"
              role="option"
              aria-selected={language === lang.code}
              className={`language-option language-option-v2${
                language === lang.code ? " active" : ""
              }`}
              onClick={() => handleLanguageChange(lang.code)}
            >
              <span className="language-flag">{lang.flag}</span>
              <span className="language-name">{lang.name}</span>
              {language === lang.code && (
                <i className="fas fa-check" aria-hidden="true"></i>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
